var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ml-5", staticStyle: { width: "95%" } },
    [
      _c("loading-overlay", {
        attrs: { active: _vm.isLoading, "can-cancel": true },
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "editapipermission-modal",
          attrs: { id: "editapipermission-modal", "hide-footer": "" },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [_vm._v("\n\t\t\tAdd Application Route\n\t\t")]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-block text-left" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "form-group",
                  attrs: { label: "Route: ", "label-for": "block-form1-name" },
                },
                [
                  _c("b-form-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.applicationedit.route,
                      callback: function ($$v) {
                        _vm.$set(_vm.applicationedit, "route", $$v)
                      },
                      expression: "applicationedit.route",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  staticClass: "form-group",
                  attrs: { label: "GET: ", "label-for": "block-form1-name" },
                },
                [
                  _c("b-form-checkbox", {
                    attrs: { switch: "", size: "lg" },
                    model: {
                      value: _vm.applicationedit.method_get,
                      callback: function ($$v) {
                        _vm.$set(_vm.applicationedit, "method_get", $$v)
                      },
                      expression: "applicationedit.method_get",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  staticClass: "form-group",
                  attrs: { label: "PUT: ", "label-for": "block-form1-name" },
                },
                [
                  _c("b-form-checkbox", {
                    attrs: { switch: "", size: "lg" },
                    model: {
                      value: _vm.applicationedit.method_put,
                      callback: function ($$v) {
                        _vm.$set(_vm.applicationedit, "method_put", $$v)
                      },
                      expression: "applicationedit.method_put",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  staticClass: "form-group",
                  attrs: { label: "POST: ", "label-for": "block-form1-name" },
                },
                [
                  _c("b-form-checkbox", {
                    attrs: { switch: "", size: "lg" },
                    model: {
                      value: _vm.applicationedit.method_post,
                      callback: function ($$v) {
                        _vm.$set(_vm.applicationedit, "method_post", $$v)
                      },
                      expression: "applicationedit.method_post",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  staticClass: "form-group",
                  attrs: { label: "DELETE: ", "label-for": "block-form1-name" },
                },
                [
                  _c("b-form-checkbox", {
                    attrs: { switch: "", size: "lg" },
                    model: {
                      value: _vm.applicationedit.method_delete,
                      callback: function ($$v) {
                        _vm.$set(_vm.applicationedit, "method_delete", $$v)
                      },
                      expression: "applicationedit.method_delete",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  staticClass: "form-group",
                  attrs: {
                    label: "Auth level: ",
                    "label-for": "block-form1-name",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.applicationedit.authLevel,
                      callback: function ($$v) {
                        _vm.$set(_vm.applicationedit, "authLevel", $$v)
                      },
                      expression: "applicationedit.authLevel",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "mt-3",
              attrs: { block: "" },
              on: {
                click: function ($event) {
                  return _vm.saveSetting()
                },
              },
            },
            [_vm._v("\n\t\t\tSave\n\t\t")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "base-block",
        { attrs: { title: "Existing application routes", "header-bg": "" } },
        [_c("div", { ref: "editApiPermissionsTable" })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }